import React, {useContext} from 'react';
import { UserActivationContext } from "./ShareStates";

const AccountActivatedForm = () => {
    const {loginUrl} = useContext(UserActivationContext);

    const redirectToLogin = (event) => {
        // console.log(event.target.id);
        event.preventDefault();
        if (event.target.id === "login") {
            return window.location = loginUrl
        }
    }

    return (
        <React.Fragment>
            <h1>Your account was activated</h1>
            <div>
                <p className={"loginStatement"}>
                    You have successfully activated your account and it is now ready for use.
                </p>
            </div>
            <a id={"login"} href={"/"} style={{cursor: "pointer"}} onClick={redirectToLogin}>Click to Login</a>
        </React.Fragment>
    )
}

export default AccountActivatedForm;